<template>
    <div class="account">
        <el-breadcrumb separator-class="el-icon-arrow-right" v-if="postList.headerTitle">
            <el-breadcrumb-item>合作规划</el-breadcrumb-item>
        </el-breadcrumb>
        <el-row class="main_header">
            <div class="main_header_item" v-if="postList.code">
                <el-input v-model="code" placeholder="请输入代码" clearable @keyup.enter.native="getList(0, 1)"></el-input>
            </div>
            <div class="main_header_item" v-if="postList.product_rid">
                <el-select v-model="product_rid" placeholder="请选择产品" clearable filterable>
                    <el-option v-for="item in productOptions" :key="item.rid" :label="item.name" :value="item.rid"> </el-option>
                </el-select>
            </div>
            <div class="main_header_item" v-if="postList.province_rid">
                <el-select v-model="province_rid" placeholder="请选择省份" clearable @change="provinceChange" filterable>
                    <el-option v-for="item in provincesOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                </el-select>
            </div>
            <div class="main_header_item" v-if="postList.city_rid">
                <el-select v-model="city_name" placeholder="请选择城市" clearable filterable value-key="value" @change="cityChange">
                    <el-option v-for="item in cityOptions" :key="item.value" :label="item.label" :value="item"> </el-option>
                </el-select>
            </div>
            <div class="main_header_item" v-if="postList.partner_rid">
                <el-select
                    v-model="partner_name"
                    filterable
                    remote
                    reserve-keyword
                    placeholder="请输入合作方搜索"
                    :remote-method="remotePartner"
                    :loading="partnerLoading"
                    clearable
                    value-key="rid"
                    @change="partnerChange"
                >
                    <el-option v-for="item in partnerOptions" :key="item.rid" :label="item.name" :value="item"> </el-option>
                </el-select>
            </div>
            <div class="main_header_item" v-if="postList.feature_code">
                <el-input v-model="feature_code" placeholder="请输入特征码" clearable @keyup.enter.native="getList(0, 1)"></el-input>
            </div>
            <div class="main_header_item" v-if="postList.timeliness">
                <el-select filterable v-model="timeliness" placeholder="请选择时效性" clearable>
                    <el-option v-for="item in timelinessOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                </el-select>
            </div>
            <div class="main_header_item" v-if="postList.approval_status">
                <el-select filterable v-model="approval_status" placeholder="请选择审批状态" clearable>
                    <el-option v-for="item in approvalOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                </el-select>
            </div>
            <div class="main_header_item" v-if="postList.date">
                <el-date-picker
                    v-model="date"
                    type="daterange"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                    @change="dateChange"
                    clearable
                >
                </el-date-picker>
            </div>
        </el-row>
        <div class="main_list">
            <div class="flex">
                <el-button size="small" plain @click="addAcount" icon="el-icon-plus" v-if="postList.addBtn">新增合作规划</el-button>
                <el-button class="btn_success" size="small" plain @click="okPass(3)" :loading="btnLoading3" v-if="postList.okBtn"
                    >批量通过</el-button
                >
                <el-button class="btn_error" size="small" plain @click="okPass(4)" :loading="btnLoading4" v-if="postList.okBtn"
                    >批量拒绝</el-button
                >
                <div class="main_header_btns">
                    <el-button type="primary" size="small" @click="getList(0, 1)" v-if="postList.searchBtn">搜索</el-button>
                    <el-button size="small" type="primary" plain @click="reset" v-if="postList.resetBtn">重置</el-button>
                    <el-button
                        size="small"
                        plain
                        icon="el-icon-bottom"
                        @click="getList(1)"
                        :loading="down_loading"
                        v-if="postList.downFileBtn"
                        >下载</el-button
                    >
                    <!-- 设置子组件 调整列显示隐藏 顺序 -->
                    <draggableList :draggable="draggable" @isErrShow="isErrshow" v-if="postList.setBtn"></draggableList>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                ref="tableDataRef"
                @sort-change="changeSort"
                :max-height="this.$tableHeight"
                @header-dragend="changeColWidth"
                class="partner_scheme"
                v-loading="loading"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.8)"
                style="width: 100%"
                @selection-change="selectionChange"
            >
                <el-table-column type="selection" width="45" fixed="left" v-if="tab_type == '2'"></el-table-column>
                <template v-for="(item, index) in colData">
                    <el-table-column
                        :key="index"
                        :prop="item.prop"
                        :label="item.title"
                        :min-width="item.width"
                        :sortable="item.sort"
                        align="left"
                        show-overflow-tooltip
                        v-if="colData[index].is_show"
                    >
                        <template slot-scope="scope" style="height: 100%">
                            <div v-if="item.prop == 'code' || item.prop == 'product_name' || item.prop == 'partner_name'">
                                <el-link type="primary" @click="handleClick(scope.row, item.prop)" style="font-size: 11px"
                                    >{{ scope.row[item.prop] }}
                                </el-link>
                            </div>
                            <div v-else>
                                <span> {{ scope.row[item.prop] }} </span>
                            </div>
                        </template>
                    </el-table-column>
                </template>
                <el-table-column label="操作" width="80" fixed="right">
                    <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" content="复制" placement="top-start">
                            <i class="el-icon-menu" @click="copy(scope.row.rid)"></i>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="编辑" placement="top-start">
                            <i class="el-icon-s-claim" @click="editDetails(scope.row.rid)"></i>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="删除" placement="top-start">
                            <i class="el-icon-delete-solid" @click="amend(scope.row.id)"></i>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total,prev, pager, next, sizes, jumper"
                    @current-change="currentChange"
                    @size-change="sizeChange"
                    :page-sizes="[10, 25, 50, 75, 100]"
                    :current-page.sync="page"
                    :page-size="row"
                    :total="total"
                ></el-pagination>
            </div>
        </div>
        <el-dialog :close-on-click-modal="false" title="审核意见" :visible.sync="dialogVisible" width="30%" v-dialogDrag>
            <el-input type="textarea" :rows="2" placeholder="请输入审核意见" v-model="comment"> </el-input>
            <span slot="footer" class="dialog-footer">
                <el-button
                    @click="
                        dialogVisible = false;
                        comment = '';
                    "
                    >取 消</el-button
                >
                <el-button type="primary" @click="subData">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import { onReSize } from '../../../../../js/common';
import draggableList from '../../../../common/Drawer.vue';
export default {
    inject: ['reload'],
    //注册draggable组件
    components: {
        draggableList
    },
    name: 'CooperationListComponent',
    data() {
        return {
            draggable: {
                data_name: 'partner_scheme'
            },
            down_loading: false,
            tableData: [],
            colData: [],
            total: 0,
            page: 1,
            row: 25,
            sort: '', //排序参数
            data_name: '', //排序参数
            loading: true,
            dataType: '',
            comment: '', //意见说明
            dialogVisible: false,
            btnLoading3: false,
            btnLoading4: false,
            partnerLoading: false,
            code: '', //code
            province_rid: '', //省份id
            product_rid: '', //产品id
            city_rid: '', //城市ID
            city_name: '',
            partner_rid: '', //合作方名称
            partner_name: '',
            feature_code: '', //级别
            timeliness: '', //时效性
            approval_status: '', //审批状态
            date: '', //时间
            start_date: '', //开始时间
            end_date: '', //结束时间
            provincesOptions: [], //省份列表
            productOptions: [], //产品列表
            cityOptions: [], //城市列表
            partnerOptions: [], //合作方列表
            tab_type: '', // tab参数1或2
            //时效性列表
            timelinessOptions: [
                {
                    value: '1',
                    label: '效期前'
                },
                {
                    value: '2',
                    label: '效期中'
                },
                {
                    value: '3',
                    label: '效期后'
                }
            ],
            //审批状态列表
            approvalOptions: [
                {
                    value: '2',
                    label: '审批中'
                },
                {
                    value: '3',
                    label: '已批准'
                },
                {
                    value: '4',
                    label: '已否决'
                }
            ],
            selected: []
        };
    },
    props: {
        postList: {
            type: Object
        }
    },
    beforeMount() {
        this.tab_type = this.postList.params.tab_type;
        //详情内调用不用本地存储的params
        //列表页面调用 优先取本地存储
        var paramsList = JSON.parse(localStorage.getItem('paramsList'));
        if (this.tab_type == 1) {
            if (paramsList['cooperation_params1']) {
                this.page = paramsList['cooperation_params1'].page;
                this.row = paramsList['cooperation_params1'].row;
                this.code = paramsList['cooperation_params1'].code;
                // this.data_name = paramsList['cooperation_params1'].data_name;
                // this.sort = paramsList['cooperation_params1'].sort;
                this.product_rid = paramsList['cooperation_params1'].product_rid;
                this.city_rid = paramsList['cooperation_params1'].city_rid;
                this.city_name = paramsList['cooperation_params1'].city_name;
                this.province_rid = paramsList['cooperation_params1'].province_rid;
                this.partner_rid = paramsList['cooperation_params1'].partner_rid;
                this.partner_name = paramsList['cooperation_params1'].partner_name;
                this.start_date = paramsList['cooperation_params1'].start_date;
                this.end_date = paramsList['cooperation_params1'].end_date;
                this.date = paramsList['cooperation_params1'].date;
                this.timeliness = paramsList['cooperation_params1'].timeliness;
                this.approval_status = paramsList['cooperation_params1'].approval_status;
                this.feature_code = paramsList['cooperation_params1'].feature_code;
            }
        } else if (this.tab_type == 2) {
            if (paramsList['cooperation_params2']) {
                this.page = paramsList['cooperation_params2'].page;
                this.row = paramsList['cooperation_params2'].row;
                this.code = paramsList['cooperation_params2'].code;
                // this.data_name = paramsList['cooperation_params2'].data_name;
                // this.sort = paramsList['cooperation_params2'].sort;
                this.product_rid = paramsList['cooperation_params2'].product_rid;
                this.city_rid = paramsList['cooperation_params2'].city_rid;
                this.city_name = paramsList['cooperation_params2'].city_name;
                this.province_rid = paramsList['cooperation_params2'].province_rid;
                this.partner_rid = paramsList['cooperation_params2'].partner_rid;
                this.partner_name = paramsList['cooperation_params2'].partner_name;
                this.start_date = paramsList['cooperation_params2'].start_date;
                this.end_date = paramsList['cooperation_params2'].end_date;
                this.date = paramsList['cooperation_params2'].date;
                this.timeliness = paramsList['cooperation_params2'].timeliness;
                this.approval_status = paramsList['cooperation_params2'].approval_status;
                this.feature_code = paramsList['cooperation_params2'].feature_code;
            }
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.selectedColData(); //筛选列
            this.getProduct(); //获取产品列表
            this.getProvinces(); //获取省份
            if (this.postList.params) {
                //如果详情列表需要搜索参数 重置按钮放出来 注意 传来的id不可被重置掉
                this.getList(0); //获取列表
            } else {
                this.getList(0); //获取列表
            }
        });
    },
    methods: {
        //子组件更新完毕
        isErrshow(data) {
            //刷新下页面
            this.reload();
        },
        //列宽改变事件
        changeColWidth(nw, ow, col, evt) {
            onReSize('partner_scheme', this);
        },
        //筛选列
        selectedColData() {
            this.colData = JSON.parse(localStorage.getItem('dataList')).partner_scheme;
        },
        //新增
        addAcount() {
            this.$router.push({
                path: 'cooperationEdit',
                query: {
                    type: 3
                }
            });
        },
        //前往编辑页面
        editDetails(id) {
            this.$router.push({
                path: 'cooperationEdit',
                query: {
                    type: 1,
                    id: id
                }
            });
        },
        //复制页面
        copy(id) {
            this.$router.push({
                path: 'cooperationEdit',
                query: {
                    type: 5,
                    id: id
                }
            });
        },
        //删除当前行
        amend(id) {
            var params = {
                id: id
            };
            let messages = '此操作将删除此条数据，是否继续?';
            this.$msgbox(messages, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    this.$api
                        .partnerSchemeDelete(params)
                        .then((res) => {
                            if (res.code == 0) {
                                this.$message({
                                    showClose: true,
                                    message: '删除成功',
                                    type: 'success'
                                });
                                this.getList(0);
                            }
                        })
                        .catch((error) => {
                            
                        });
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
        },
        // 从后台获取数据,重新排序
        changeSort(val) {
            this.data_name = val.prop;
            if (val.order == 'ascending') {
                this.sort = 'asc';
            } else if (val.order == 'descending') {
                this.sort = 'desc';
            }
            var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
            if (this.tab_type == 1) {
                if (newParamsList['cooperation_params1']) {
                    newParamsList['cooperation_params1'].data_name = val.prop;
                    newParamsList['cooperation_params1'].sort = this.sort;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                }
            } else if (this.tab_type == 2) {
                if (newParamsList['cooperation_params2']) {
                    newParamsList['cooperation_params2'].data_name = val.prop;
                    newParamsList['cooperation_params2'].sort = this.sort;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                }
            }
            if (this.sort !== '') {
                this.getList(0); //获取列表
            }
        },
        //跳转详情
        handleClick(row, prop) {
            if (prop == 'code') {
                this.$router.push({
                    path: '/cooperationDetail',
                    query: {
                        id: row.rid
                    }
                });
            } else if (prop == 'product_name') {
                this.$router.push({
                    path: '/productListDetails',
                    query: {
                        id: row.product_rid
                    }
                });
            } else if (prop == 'partner_name') {
                this.$router.push({
                    path: '/partnerDetails',
                    query: {
                        id: row.partner_rid
                    }
                });
            }
        },
        partnerChange(value) {
            if (value) {
                this.partner_name = value.name;
                this.partner_rid = value.rid;
            } else {
                this.partner_name = '';
                this.partner_rid = '';
            }
        },
        cityChange(value) {
            if (value) {
                this.city_name = value.label;
                this.city_rid = value.value;
            } else {
                this.city_name = '';
                this.city_rid = '';
            }
        },
        //获取列表数据
        getList(type_data, type) {
            if (type == 1) {
                this.page = 1;
            }
            var params = {
                page: this.page,
                row: this.row,
                code: this.code,
                product_rid: this.product_rid,
                city_rid: this.city_rid,
                city_name: this.city_name,
                province_rid: this.province_rid,
                partner_rid: this.partner_rid,
                partner_name: this.partner_name,
                start_date: this.start_date,
                end_date: this.end_date,
                date: this.date,
                timeliness: this.timeliness,
                approval_status: this.approval_status,
                sort: [this.data_name, this.sort],
                feature_code: this.feature_code,
                is_export: type_data,
                tab_type: this.tab_type
            };
            //当点击 或者触发回车事件保存参数
            if (type == 1) {
                if (this.tab_type == 1) {
                    var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                    newParamsList['cooperation_params1'] = params;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                } else if (this.tab_type == 2) {
                    var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                    newParamsList['cooperation_params2'] = params;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                }
            }
            if (type_data == 0) {
                this.loading = true;
                this.$api
                    .partnerSchemeLists(params)
                    .then((res) => {
                        this.loading = false;
                        if (res.code == 0) {
                            this.tableData = res.data.data;
                            this.total = res.data.total;
                            //判断当前搜素页面参数是否大于最后一页 大于的话取最后一页的参数存起来并用最后一页的参数请求
                            if (res.data.current_page > res.data.last_page) {
                                if (this.tab_type == 1) {
                                    var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                                    newParamsList['cooperation_params1'].page = res.data.last_page;
                                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                                    this.page = res.data.last_page;
                                } else if (this.tab_type == 2) {
                                    var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                                    newParamsList['cooperation_params2'].page = res.data.last_page;
                                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                                    this.page = res.data.last_page;
                                }
                            }
                        }
                    })
                    .catch((error) => {
                        this.loading = false;
                        
                    });
            } else {
                this.down_loading = true;
                params.page = 1;
                this.$api
                    .partnerSchemeListsDownFile(params)
                    .then((res) => {
                        this.$message({
                            message: '下载成功!',
                            type: 'success'
                        });
                        this.down_loading = false;
                    })
                    .catch((error) => {
            
                        this.down_loading = false;
                        
                    });
            }
        },
        // 点击分页当前页数
        currentChange(val) {
            this.page = val;
            //当分页发生改变的时候存到本地更改本地存储好的参数
            var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
            if (this.tab_type == 1) {
                if (newParamsList['cooperation_params1']) {
                    newParamsList['cooperation_params1'].page = val;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                } else {
                    var params = {
                        page: this.page,
                        row: this.row,
                        code: this.code,
                        product_rid: this.product_rid,
                        city_rid: this.city_rid,
                        city_name: this.city_name,
                        province_rid: this.province_rid,
                        partner_rid: this.partner_rid,
                        partner_name: this.partner_name,
                        start_date: this.start_date,
                        end_date: this.end_date,
                        date: this.date,
                        timeliness: this.timeliness,
                        approval_status: this.approval_status,
                        sort: [this.data_name, this.sort],
                        feature_code: this.feature_code
                    };
                    var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                    newParamsList['cooperation_params1'] = params;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                }
            } else if (this.tab_type == 2) {
                if (newParamsList['cooperation_params2']) {
                    newParamsList['cooperation_params2'].page = val;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                } else {
                    var params = {
                        page: this.page,
                        row: this.row,
                        code: this.code,
                        product_rid: this.product_rid,
                        city_rid: this.city_rid,
                        city_name: this.city_name,
                        province_rid: this.province_rid,
                        partner_rid: this.partner_rid,
                        partner_name: this.partner_name,
                        start_date: this.start_date,
                        end_date: this.end_date,
                        date: this.date,
                        timeliness: this.timeliness,
                        approval_status: this.approval_status,
                        sort: [this.data_name, this.sort],
                        feature_code: this.feature_code
                    };
                    var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                    newParamsList['cooperation_params2'] = params;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                }
            }
            this.getList(0);
        },
        // 切换每页条数
        sizeChange(val) {
            this.row = val;
            //当页数发生改变的时候存到本地更改本地存储好的参数
            var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
            if (this.tab_type == 1) {
                if (newParamsList['cooperation_params1']) {
                    newParamsList['cooperation_params1'].row = val;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                } else {
                    var params = {
                        page: this.page,
                        row: this.row,
                        code: this.code,
                        product_rid: this.product_rid,
                        city_rid: this.city_rid,
                        city_name: this.city_name,
                        province_rid: this.province_rid,
                        partner_rid: this.partner_rid,
                        partner_name: this.partner_name,
                        start_date: this.start_date,
                        end_date: this.end_date,
                        date: this.date,
                        timeliness: this.timeliness,
                        approval_status: this.approval_status,
                        sort: [this.data_name, this.sort],
                        feature_code: this.feature_code
                    };
                    var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                    newParamsList['cooperation_params1'] = params;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                }
            } else if (this.tab_type == 2) {
                if (newParamsList['cooperation_params2']) {
                    newParamsList['cooperation_params2'].row = val;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                } else {
                    var params = {
                        page: this.page,
                        row: this.row,
                        code: this.code,
                        product_rid: this.product_rid,
                        city_rid: this.city_rid,
                        city_name: this.city_name,
                        province_rid: this.province_rid,
                        partner_rid: this.partner_rid,
                        partner_name: this.partner_name,
                        start_date: this.start_date,
                        end_date: this.end_date,
                        date: this.date,
                        timeliness: this.timeliness,
                        approval_status: this.approval_status,
                        sort: [this.data_name, this.sort],
                        feature_code: this.feature_code
                    };
                    var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                    newParamsList['cooperation_params2'] = params;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                }
            }
            this.getList(0);
        },
        //重置页面数据
        reset() {
            this.date = '';
            this.code = '';
            this.product_rid = '';
            this.city_rid = '';
            this.city_name = '';
            this.province_rid = '';
            this.partner_rid = '';
            this.partner_name = '';
            this.start_date = '';
            this.end_date = '';
            this.timeliness = '';
            this.approval_status = '';
            this.feature_code = '';
            this.sort = '';
            this.data_name = '';
            this.parent_rid = '';
            this.page = 1;
            this.row = 25;
            var params = {
                page: 1,
                row: 25,
                sort: ['', ''],
                date: '',
                code: '',
                product_rid: '',
                city_rid: '',
                city_name: '',
                province_rid: '',
                partner_rid: '',
                partner_name: '',
                start_date: '',
                end_date: '',
                date: '',
                timeliness: '',
                approval_status: '',
                feature_code: '',
                parent_rid: ''
            };
            var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
            if (this.tab_type == 1) {
                newParamsList['cooperation_params1'] = params;
                localStorage.setItem('paramsList', JSON.stringify(newParamsList));
            } else if (this.tab_type == 2) {
                newParamsList['cooperation_params2'] = params;
                localStorage.setItem('paramsList', JSON.stringify(newParamsList));
            }
            this.getList(0);
        },
        //合作方搜索
        remotePartner(query) {
            if (query !== '') {
                this.partnerLoading = true;
                let params = {
                    name: query
                };
                this.$api
                    .searchPartners(params)
                    .then((res) => {
                        if (res.code == 0) {
                            this.partnerLoading = false;
                            this.partnerOptions = res.data;
                        } else {
                            this.partnerOptions = [];
                        }
                    })
                    .catch((error) => {
                        
                    });
            } else {
                this.partnerLoading = false;
                this.partnerOptions = [];
            }
        },
        //获取产品
        getProduct() {
            let params = {
                has_all: '1'
            };
            this.$api
                .dropdownProducts(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.productOptions = res.data;
                    }
                })
                .catch((error) => {
                    
                });
        },
        //获取省份
        getProvinces() {
            let params = {
                has_all: '0'
            };
            this.$api
                .provinces(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.provincesOptions = [];
                        let data = res.data;
                        data.forEach((value, index) => {
                            this.provincesOptions.push({
                                value: value.rid,
                                label: value.name
                            });
                        });
                    }
                })
                .catch((error) => {
                    
                });
        },
        //省份改变请求当下省份下的城市
        provinceChange() {
            this.cityOptions = [];
            this.city_rid = '';
            this.city_name = '';
            if (this.province_rid) {
                let params = {
                    parent_rid: this.province_rid
                };
                this.$api
                    .cities(params)
                    .then((res) => {
                        if (res.code == 0) {
                            this.cityOptions = [];
                            let data = res.data;
                            data.forEach((value, index) => {
                                this.cityOptions.push({
                                    value: value.rid,
                                    label: value.name
                                });
                            });
                        }
                    })
                    .catch((error) => {
                        
                    });
            }
        },
        //时间框赋值
        dateChange(val) {
            if (val) {
                this.start_date = val[0];
                this.end_date = val[1];
            } else {
                this.start_date = '';
                this.end_date = '';
            }
        },
        //type == 3审批通过 type ==4 拒绝
        okPass(type) {
            this.dataType = type;
            if (this.selected.length == 0) {
                this.$message.warning('当前未选择审核数据！');
                return false;
            } else {
                this.dialogVisible = true;
            }
        },
        //提交通过拒绝弹窗
        subData() {
            if (this.dataType == 3) {
                //此处为通过
                this.btnLoading3 = true;
                let approvalList = [];
                this.selected.forEach((value) => {
                    approvalList.push(value.rid);
                });
                let postData = {
                    rids: approvalList,
                    approval_status: 3,
                    comment: this.comment
                };
                this.$api
                    .partnerSchemeBatchAudit(postData)
                    .then((res) => {
                        this.btnLoading3 = false;
                        this.comment = '';
                        if (res.code == 0) {
                            this.$message({
                                message: '操作成功!',
                                type: 'success'
                            });
                            this.getList(0); //获取列表
                            this.$emit('isCountShow'); //事件发射
                            this.dialogVisible = false;
                        } else if (res.code == 1900) {
                            this.$message({
                                message: '批量修改成功，部分数据没有权限修改!',
                                type: 'success'
                            });
                            this.getList(0); //获取列表
                            this.$emit('isCountShow'); //事件发射
                            this.dialogVisible = false;
                        }
                    })
                    .catch((error) => {
                        this.btnLoading3 = false;
                        this.dialogVisible = false;
                        
                    });
            } else if (this.dataType == 4) {
                //此处为拒绝
                this.btnLoading4 = true;
                let approvalList = [];
                this.selected.forEach((value) => {
                    approvalList.push(value.rid);
                });
                let postData = {
                    rids: approvalList,
                    approval_status: 4,
                    comment: this.comment
                };
                this.$api
                    .partnerSchemeBatchAudit(postData)
                    .then((res) => {
                        this.btnLoading4 = false;
                        this.comment = '';
                        if (res.code == 0) {
                            this.$message({
                                message: '操作成功!',
                                type: 'success'
                            });
                            this.getList(0); //获取列表
                            this.$emit('isCountShow'); //事件发射
                            this.dialogVisible = false;
                        } else if (res.code == 1900) {
                            this.$message({
                                message: '批量修改成功，部分数据没有权限修改!',
                                type: 'success'
                            });
                            this.getList(0); //获取列表
                            this.$emit('isCountShow'); //事件发射
                            this.dialogVisible = false;
                        }
                    })
                    .catch((error) => {
                        this.btnLoading4 = false;
                        this.dialogVisible = false;
                        
                    });
            }
        },
        // 多选选择框选择
        selectionChange(val) {
            this.selected = val;
        }
    }
};
</script>
<style lang="scss" scoped>
/deep/ .el-table__empty-block {
    width: 100% !important;
    min-width: 100% !important;
    max-width: 100% !important;
    padding-right: 100% !important;
}
</style>